import React from "react";
import { Phone, Mail, MapPin, ShieldCheck, Award } from "lucide-react";
import { Link } from "react-router-dom";
import { mockData, LOGO_URL } from "../mock";

export const Footer = () => {
  const year = new Date().getFullYear();

  const quickLinks = [
    { label: "About", path: "/about" },
    { label: "Founder", path: "/founders" },
    { label: "Services", path: "/services" },
    { label: "Portfolio", path: "/portfolio" },
    { label: "Careers", path: "/careers" },
    { label: "Contact", path: "/contact" },
  ];

  return (
    <footer data-testid="site-footer" className="tex-plate border-t border-border">
      <div className="hazard-stripe h-1.5 w-full" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img
                src={LOGO_URL}
                alt="Robo Demo LLC Logo"
                className="h-16 w-16 object-contain"
              />
              <div>
                <h3 className="font-display text-2xl font-extrabold uppercase tracking-tight text-white">
                  Robo Demo<span className="text-primary"> LLC</span>
                </h3>
                <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mt-1">
                  Service Disabled Veteran Owned
                </p>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed max-w-md mb-6">
              Professional demolition and site work delivered with military
              precision and uncompromising safety standards. From residential
              teardowns to large-scale commercial demolition across the DMV and
              nationwide.
            </p>
            <div className="flex flex-wrap gap-3">
              <div className="flex items-center gap-2 border border-border bg-surface px-3 py-2">
                <ShieldCheck className="h-4 w-4 text-primary" />
                <span className="text-sm text-gray-300">Licensed &amp; Insured</span>
              </div>
              <div className="flex items-center gap-2 border border-border bg-surface px-3 py-2">
                <Award className="h-4 w-4 text-primary" />
                <span className="text-sm text-gray-300">SDVOSB Certified</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="label-kicker mb-6">Navigate</h4>
            <nav className="space-y-3">
              {quickLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`footer-link-${link.label.toLowerCase()}`}
                  className="block text-gray-400 hover:text-primary transition-colors duration-200"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="label-kicker mb-6">Contact</h4>
            <div className="space-y-4">
              <a
                href={`tel:${mockData.contact.phone}`}
                className="flex items-center gap-3 text-gray-400 hover:text-primary transition-colors"
              >
                <Phone className="h-5 w-5 text-primary flex-shrink-0" />
                {mockData.contact.phone}
              </a>
              <a
                href={`mailto:${mockData.contact.email}`}
                className="flex items-center gap-3 text-gray-400 hover:text-primary transition-colors break-all"
              >
                <Mail className="h-5 w-5 text-primary flex-shrink-0" />
                {mockData.contact.email}
              </a>
              <div className="flex items-start gap-3 text-gray-400">
                <MapPin className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                {mockData.contact.serviceArea}
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-border pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground text-center md:text-left">
            © {year} Robo Demo LLC. All rights reserved. Service-Disabled
            Veteran-Owned Small Business.
          </p>
          <div className="flex gap-6 text-sm text-muted-foreground">
            <span>Safety First</span>
            <span>Precision Always</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
